import { render } from "./clientsearch.vue?vue&type=template&id=136ae7dc"
import script from "./clientsearch.vue?vue&type=script&lang=js"
export * from "./clientsearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__